import * as r from "./index.js";
import i from "./mixin.js";
var m = i(r);
m._ = m;
export { m as default };